import { Link } from 'react-router-dom';
import Button from '../components/Button';
import ReviewAction from '../components/ReviewAction';
import Sidebar from '../components/Sidebar';
import SliderAuthor from '../components/SliderAuthor';
import ScrollToTop from '../components/ScrollToTop';

function Home({ allIssues }) {
  console.log(allIssues);

  const handleSubscribe = () => {
    window.open('https://putsoseol.stibee.com/subscribe');
  };

  return (
    <div className="whole-section">
      <Sidebar />
      <div className="home-container">
        <SliderAuthor allIssues={allIssues} />
        {/* <button className="subscribe-btn">구독하러 가기</button> */}
        <div className='subscribe-text'>뉴스레터를 구독하고 풋소설을 만나보세요</div>
        <Button text="풋소설 구독하기" className="subscribe-btn" onClick={handleSubscribe} />
        {/* <Button text="후기 테스트 버튼" className='reveiw-btn' onClick={} */}
        {/* <ReviewAction /> */}
      </div>

      <section className="info-section">
        <div className="link-box">
          인스타그램
          <a href="https://www.instagram.com/putsoseol?igsh=MWo0czl4ZGlnZW5uZg%3D%3D">@putsoseol</a>
        </div>
        {/* <div className="link-box">
          링크트리
          <a href="https://putsoseol.stibee.com/subscribe">링크트리</a>
        </div> */}
      </section>

      <section className="footer-section">copyright©putsoseol</section>
      <ScrollToTop />
    </div>
  );
}

export default Home;
